import React from "react";
import PropTypes from "prop-types";
import ShowHideColumnModal from "../../components/common/columnModal/ShowHideColumnModal";
import { DEFAULT_COLUMNS, ALL_COLUMNS } from "./utils";
import { formatWithTimezone } from "../../utils/dateUtils";

const ReportShowHideColumnModal = ({
  isShowHideColumn,
  isOffline,
  setIsShowHideColumn,
  settingColumn,
  timezoneSuffix,
}) => {
  // Filter out hidden columns and format with timezone
  const allColumns = ALL_COLUMNS.filter((col) => !col.isHidden).map((col) =>
    formatWithTimezone(col, timezoneSuffix)
  );

  // Custom settingColumn function to handle timezone formatting
  const handleSettingColumn = (selectedColumns) => {
    const checkedColumns = ALL_COLUMNS.filter((col) => {
      return selectedColumns.find((column) => column.dataKey === col.dataKey);
    }).map((col) => formatWithTimezone(col, timezoneSuffix));
    settingColumn(checkedColumns);
  };

  return (
    <ShowHideColumnModal
      isShowHideColumn={isShowHideColumn}
      setIsShowHideColumn={setIsShowHideColumn}
      settingColumn={handleSettingColumn}
      columns={DEFAULT_COLUMNS}
      allColumns={allColumns}
      defaultColumns={DEFAULT_COLUMNS}
      title="Show / hide columns"
    />
  );
};

ReportShowHideColumnModal.propTypes = {
  isShowHideColumn: PropTypes.bool.isRequired,
  isOffline: PropTypes.bool.isRequired,
  setIsShowHideColumn: PropTypes.func.isRequired,
  settingColumn: PropTypes.func.isRequired,
  timezoneSuffix: PropTypes.string,
};

export default ReportShowHideColumnModal;
